import { API_URL, jwtToken } from "../../../context/appContext";
export default async function fetchProfiles() {
    return fetch(`${API_URL}/api/profile`, {
        method: "GET",
        headers: {
            'Authorization': 'Bearer ' + jwtToken
        }
    })
        .then(res => res.json())
        .then(res => res)
        .catch(err => err)
}
